export const blockIconsActionFavorite = (
	<span className='material-symbols-outlined'>favorite</span>
);
